import Link from 'next/link';
import cn from 'classnames';
import { LayoutContainer, Picture } from '@petsmart-ui/sparky';
import { ContentfulClick } from '@libs/analytics';
import { HeaderCtaTracker } from '../../../utils/HeaderCtaTracker';
import { getImageProps } from '../../../utils/propsImagesItems';
import type { CampaignCarsUpProps } from '../types';
import { colorMap } from '../utils';
import { Text } from '../../Text';

import './3up.scss';

export function CampaignCards3up({
    header,
    body,
    cards,
    textLink,
    textLinkColor,
    textColor,
    backgroundFill,
    cardsTextColor,
}: CampaignCarsUpProps) {
    return (
        <LayoutContainer className="campaign-cards-3up">
            <div className="campaign-cards-3up__content" style={{ background: backgroundFill }}>
                <div className="campaign-cards-3up__header">
                    <Text color={textColor} as="h2">
                        {header}
                    </Text>

                    <Text align="center" color={textColor}>
                        {body}
                    </Text>

                    {textLink && (
                        <HeaderCtaTracker
                            textLink={textLink}
                            linkTextColor={textLinkColor}
                            header={header ?? ''}
                            promoVariant="campaign cards up - 3up"
                            promoType="campaign-cards-3up__card"
                        />
                    )}
                </div>

                <div className="campaign-cards-3up__cards">
                    {cards.slice(0, 3).map((c, index) => {
                        const cm = colorMap[cardsTextColor];
                        const linkUrl = c?.link?.webUrl || textLink?.link?.webUrl || '';
                        const Component = linkUrl ? Link : 'div';

                        return (
                            <ContentfulClick
                                component={Component}
                                key={c.sysId}
                                className="campaign-cards-3up__card"
                                style={{ background: c.backgroundFill }}
                                href={linkUrl}
                                eventData={{
                                    position: index + 1,
                                    linkText: cn(c.preheader, c.header, c.body),
                                    linkUrl,
                                    promoTitle: header ?? '',
                                    promoVariant: 'campaign cards up - 3up',
                                    promoDesc: c.internalTitle,
                                    promoType: 'campaign-cards-3up__card',
                                }}
                                prefetch={false} // https://petsmart.atlassian.net/browse/HCP-594
                            >
                                <div className="campaign-cards-3up__card-content">
                                    <Text color={cm?.preheaderColor} className="campaign-cards-3up__card-preheader">
                                        {c.preheader}
                                    </Text>
                                    <Text as="h2" color={cm?.headingColor}>
                                        {c.header}
                                    </Text>
                                    <Text color={cm?.textColor} className="campaign-cards-3up__card-body">
                                        {c.body}
                                    </Text>
                                    <Text color={cm?.textColor} className="campaign-cards-3up__card-terms">
                                        {c.terms}
                                    </Text>
                                </div>

                                <Picture {...getImageProps(c.image)} />
                            </ContentfulClick>
                        );
                    })}
                </div>
            </div>
        </LayoutContainer>
    );
}
